/*
 * @Author: zhengxiaowen
 * @Date: 2018-09-21 09:22:12
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-12 16:52:27
 */

import {nativeApi} from '../index'
export default {
  state: {
    isUnReadHints: false
  },
  getters: {

  },
  mutations: {
    SET_ROOM_UNREAD_HINTS (state, val) {
      state.isUnReadHints = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/store/ImStore.js